$(document).ready(function () {
    $('.category-checkbox').on('change', function () {
        const selected = $('.category-checkbox:checked').map(function () {
            return $(this).val();
        }).get();

        const url = new URL(window.location.origin + window.location.pathname);

        if (selected.length > 0) {
            url.searchParams.set('categories', selected.join(','));
        }

        window.location.href = url.toString();
    });
});
